import { Pipe, PipeTransform } from '@angular/core';
import { marked } from 'marked';

@Pipe({
  name: 'markdown',
  standalone: true
})
export class MarkdownPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    // Step 1: handle custom bold formatting (**text**)
    let processedValue = this.processBoldText(value);

    // Step 2: replace figure references like [[UW_Doc]] with styled span
    processedValue = this.replaceFigureReferences(processedValue);

    // Step 3: process image links (including the custom format in your response)
    processedValue = this.processImageLinks(processedValue);

    try {
      marked.setOptions({
        breaks: true,
        gfm: true,
        async: false,
        renderer: this.createCustomRenderer()
      });
      const result = marked.parse(processedValue, { async: false });
      return typeof result === 'string' ? result : processedValue;
    } catch (error) {
      console.error('Markdown parsing error:', error);
      return processedValue;
    }
  }
  /** Replace **text** with <strong>text</strong> */
  // private processBoldText(text: string): string {
  //   return text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  // }
    private processBoldText(text: string): string {
    // First handle double asterisks (**text**)
    text = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    text = text.replace(/(?<!<strong>.*?)\*([^*\n]+?)\*(?!.*?<\/strong>)/g, '<strong>$1</strong>');
    return text;
  }
  /** Replace [[UW_Doc]] with styled span */
  private replaceFigureReferences(text: string): string {
    return text.replace(/\[\[(.*?)\]\]+/g, '<span class="doc-ref">$1</span>');
  }
  /** Convert various image link formats directly to HTML img tags */
  private processImageLinks(text: string): string {
    // Handle the format in AI responses: [<img src='URL' />] and variants like [<img src = URL >]
    text = text.replace(
      /\[<img\s+[^>]*?src\s*=\s*['"]?([^'"\s>\]]+)['"]?[^>\]]*?>?\]/gi,
      '<img src="$1" class="markdown-image clickable-img" style="max-width:100%;height:auto;display:block;margin:8px auto;">'
    );

    return text;
  }

  private createCustomRenderer(): any {
    const renderer = new marked.Renderer();
    // Since we're handling images directly as HTML, we don't need custom image rendering
    renderer.paragraph = ({ tokens }: { tokens: any[] }) => {
      const raw = tokens.map(token => token.raw).join('');
      // Don't wrap img tags in paragraphs
      if (raw.trim().includes('<img')) {
        return raw;
      }
      return `<p>${raw}</p>`;
    };

    return renderer;
  }
}